import { MenuItem } from "@headlessui/react";
import { NextLink } from "../Links";
import { ReactNode } from "react";
import { cn } from "../../utils/cn";

export interface MenuItemLinkProps {
  href: string;
  children: ReactNode;
  className?: string;
  "data-testid"?: string;
}

export function MenuItemLink({
  href,
  children,
  className,
  "data-testid": testId,
}: MenuItemLinkProps) {
  return (
    <MenuItem>
      {({ focus }) => (
        <NextLink
          href={href}
          data-testid={testId}
          className={cn(
            focus ? "bg-gray-100" : "",
            "block px-4 py-2 text-sm whitespace-nowrap",
            className,
          )}
        >
          {children}
        </NextLink>
      )}
    </MenuItem>
  );
}
